import { app } from "../../../application";
import { AxiosClient } from "../../axiosClient";
import { EventRequestDTO, GuestEventPost } from "../../dtos/guest";
import { type IGuestApi } from "./IGuestApi";

export class GuestApi implements IGuestApi {

    constructor(readonly axiosClient: AxiosClient) {
    }

    public async event(dto: EventRequestDTO) {
        const response = await this.axiosClient.get(`/public/share/${dto.event}`);

        return response.data
    }

    public async joinEvent(payload: {name: string, moment: string}){
        const response = await this.axiosClient.post(`/public/moments/${payload.moment}/guest/join`, payload);
        return response.data
    }

    public async post(paylaod: GuestEventPost) {
        const guest = app().guestService.guest(paylaod.moment);
        console.log('guest', guest)
        if(guest) {
            this.axiosClient.setAuthToken(guest.token)
            const response = await this.axiosClient.post(`/moments/${paylaod.moment}/feed/create`, paylaod);
            return response.data
        }
    }
}